import FormFieldText from "shared/src/form/FormFieldText";
import FormFieldDropdown from "shared/src/form/FormFieldDropdown";
import { connect } from "react-redux";
import updateusrfield from "../../actions/updateusrfields";
import updateValidationStatus from "../../actions/updateValidationStatus";
import setsubmitted from "../../actions/setSubmitted";
import React from "react";
import FormBtn from "shared/src/form/FormBtn";
import PropTypes from "prop-types";
import FormCheckBox from "shared/src/form/FormCheckBox";
import FormTextArea from "./FormTextArea";
import {
  emailRegex,
  apiURLs,
  allFieldsValid,
  DesTransform,
  phoneRegex,
  optionalPhoneRegex,
} from "shared/src/misc/constants";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import setSeconds from "date-fns/setSeconds";
import addDays from "date-fns/addDays";

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.onUsrFieldChange = this.onUsrFieldChange.bind(this);
    this.onFieldError = this.onFieldError.bind(this);
    this.formRef = React.createRef();
    this.state = {
      awaitingSumit: false,
      forceErrChanges: false,
      tries: 0,
      disableSubmit: false,
      localFormState: {},
      errorFieldName: "generic-form",
      error: {
        show: false,
        errorMsg: "",
      },
    };
  }

  useTempState() {
    if (this.props.useTempState && this.props.useTempState === true) {
      return true;
    }
    return false;
  }

  componentDidMount() {
    if (this.useTempState()) {
      this.setState({
        localFormState: { ...this.props.usrfields },
      });
    }
  }

  onSubmit = async (e) => {
    e.preventDefault();
    //Additional form validation, can probably use this to show error messages from the server

    //
    this.setState({
      disableSubmit: true,
      forceErrChanges: !this.state.forceErrChanges,
    });
    await allFieldsValid(this.formRef, this.props);
    if (this.props.usrfields.validationErrors.length > 0) {
      //do not awaitsubmit if validation fails
      this.setState({
        tries: this.state.tries + 1,
        forceErrChanges: !this.state.forceErrChanges,
        disableSubmit: false,
      });
      return;
    } else {
      this.setState({
        tries: this.state.tries + 1,
        forceErrChanges: !this.state.forceErrChanges,
        awaitingSumit: true,
        disableSubmit: true,
      });
    }
  };

  generateGenericFormError = (error) => {
    this.setState({
      error: {
        show: true,
        errorMsg: error,
      },
    });
    this.onFieldError(this.state.errorFieldName);
  };

  clearGenericFormError = () => {
    if (this.state.error.show === true) {
      this.onFieldErrorCleared(this.state.errorFieldName); //Clear the error when the component updates. Any action will clear this error
      this.setState({ error: { show: false } }); //Hide error
    }
  };
  componentDidUpdate() {
    //How to check if we were waiting for children to update. Tries is necessary as the first try will always be different somehow
    if (this.state.awaitingSumit) {
      let validfields = this.props.usrfields.validationErrors.length === 0;
      if (validfields) {
        //If the global state that contains errors is empty we assume there is no validation errors
        this.postValidationSubmit(this.props.postSumbit);
      } else {
        this.setState({
          disableSubmit: false,
        });
      }
      //Disable this so it doesn't try to submit again
      this.setState({
        awaitingSumit: false,
      });
    }
  }

  trimAllFields(inputValues) {
    let tmp = Object.assign({}, inputValues);
    Object.keys(inputValues).forEach((key) => {
      if (typeof inputValues[key] === "string") {
        tmp[key] = tmp[key].trim();
      }
      if (key.substr(0, 2) === "qa" && typeof tmp[key]["A"] === "string") {
        tmp[key]["A"] = tmp[key]["A"].trim();
      }
    });
    return tmp;
  }

  postValidationSubmit() {
    //console.log('OK')
    //continue fetching
    this.props.preSubmit && this.props.preSubmit();
    const inputValues = this.trimAllFields(
      this.useTempState() ? this.state.localFormState : this.props.usrfields
    );
    const od = !inputValues.date && inputValues.dateOption;
    let date = setSeconds(addDays(new Date(), 1), 0);
    if (od) {
      //convert the date option to a real date
      switch (inputValues.dateOption) {
        case "Morning":
          date = setHours(setMinutes(date, 0), 10);
          break;
        case "Afternoon":
          date = setHours(setMinutes(date, 0), 12);
          break;
        case "Evening":
          date = setHours(setMinutes(date, 0), 15);
          break;
        default:
          break;
      }
    }
    let postObject = DesTransform("lead", inputValues, {
      ...(od ? { ...inputValues, date } : inputValues),
    });
    this.props.setsubmitted?.(true);
    fetch(apiURLs.lead.url, {
      method: "POST",
      body: JSON.stringify(postObject),
    })
      .then((response) => {
        if (response.ok) {
          this.setState({ isSubmitted: true });
          this.props.postSumbit?.();
        } else {
          throw Error(response.statusText);
        }
      })
      .catch((error) => {
        console.log("Request Failed: ", error);
        this.generateGenericFormError(error.toString());
        this.setState({
          disableSubmit: false,
        });
      });
  }
  onUsrFieldChange = (title, e) => {
    let value = e.target ? e.target.value : e; //handle drop down value changes
    this.clearGenericFormError();
    if (this.useTempState()) {
      this.setState({
        localFormState: {
          ...this.state.localFormState,
          [title]: value,
        },
      });
    } else {
      let titlef = title;
      this.props.updateusrfield(titlef, value);
    }
  };
  onFieldError = (errorfield) => {
    if (
      this.props.usrfields.validationErrors.filter(
        (error) => error === errorfield
      ).length === 1
    ) {
      return;
    }
    this.props.updateValidationStatus("add", errorfield);
  };
  onFieldErrorCleared = (errorfield) => {
    if (
      this.props.usrfields.validationErrors.filter(
        (error) => error === errorfield
      ).length === 0
    ) {
      return;
    }
    this.props.updateValidationStatus("remove", errorfield);
  };
  render() {
    return (
      <form
        onSubmit={(e) => this.onSubmit(e)}
        className="capture-form"
        formNoValidate="novalidate"
        noValidate="novalidate"
        ref={this.formRef}
      >
        <div className="calc-input">
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <FormFieldText
                  symbol={"\u00A0"}
                  title="First Name"
                  name="firstname"
                  value={
                    this.useTempState()
                      ? this.state.localFormState.firstname
                      : this.props.usrfields.firstname || ""
                  }
                  onChange={this.onUsrFieldChange}
                  matchesRegex={{
                    regex: "[a-zA-Z]{1,}",
                    type: "error",
                    message: "First name cannot be blank",
                  }}
                  onFieldError={this.onFieldError}
                  onFieldErrorCleared={this.onFieldErrorCleared}
                  forceErrorCheck={this.state.forceErrChanges}
                />
              </div>
              <div className="col-md-4">
                <FormFieldText
                  symbol={"\u00A0"}
                  title="Last Name"
                  name="lastname"
                  value={
                    this.useTempState()
                      ? this.state.localFormState.lastname
                      : this.props.usrfields.lastname || ""
                  }
                  onChange={this.onUsrFieldChange}
                />
              </div>
              <div className="col-md-4">
                <FormFieldText
                  symbol={"\u00A0"}
                  title="Email"
                  name="email"
                  value={
                    this.useTempState()
                      ? this.state.localFormState.email
                      : this.props.usrfields.email || ""
                  }
                  onChange={this.onUsrFieldChange}
                  matchesRegex={emailRegex}
                  onFieldError={this.onFieldError}
                  onFieldErrorCleared={this.onFieldErrorCleared}
                  forceErrorCheck={this.state.forceErrChanges}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <FormFieldText
                  symbol={"\u00A0"}
                  title="Phone Number"
                  name="phonenumber"
                  value={
                    this.useTempState()
                      ? this.state.localFormState.phonenumber
                      : this.props.usrfields.phonenumber || ""
                  }
                  onChange={this.onUsrFieldChange}
                  matchesRegex={
                    //QA3 is the preferred method of contact
                    (this.useTempState()
                      ? this.state.localFormState.qa3 &&
                        (this.state.localFormState.qa3.A || "")
                      : this.props.usrfields.qa3 &&
                        (this.props.usrfields.qa3.A || "")) === "Phone"
                      ? {
                          regex: phoneRegex,
                          type: "error",
                          message: "Please enter a valid Phone number",
                        }
                      : {
                          //#1741 - This regular expresion matches empty strings
                          //When they pick email as their preferred contact option the field will become optional
                          //Optional in this case means that it can be either blank or a valid phone number
                          //Invalid phone numbers will give you an error
                          regex: optionalPhoneRegex,
                          type: "error",
                          message: "Invalid Phone number",
                        }
                  }
                  onFieldError={this.onFieldError}
                  onFieldErrorCleared={this.onFieldErrorCleared}
                  forceErrorCheck={this.state.forceErrChanges}
                />
              </div>
              <div className="col-md-4">
                <FormFieldDropdown
                  symbol={"\u00A0"}
                  title="Preferred Time"
                  name="dateOption"
                  options={["Morning", "Afternoon", "Evening"]}
                  value={
                    this.useTempState()
                      ? this.state.localFormState.dateOption
                      : this.props.usrfields.dateOption
                  }
                  onFieldError={this.onFieldError}
                  onFieldErrorCleared={this.onFieldErrorCleared}
                  onChange={this.onUsrFieldChange}
                  isRequired={true}
                />
              </div>
              <div className="col-md-4">
                <FormFieldDropdown
                  symbol={"\u00A0"}
                  title="Preferred method of contact"
                  name="qa3"
                  options={["Phone", "Email"]}
                  value={
                    this.useTempState()
                      ? this.state.localFormState.qa3 &&
                        (this.state.localFormState.qa3.A || "")
                      : this.props.usrfields.qa3 &&
                        (this.props.usrfields.qa3.A || "")
                  }
                  onChange={(title, e) => {
                    let value = e.target ? e.target.value : e;
                    this.onUsrFieldChange(title, {
                      Q: "Preferred method of contact",
                      A: value,
                    });
                  }}
                  onFieldError={this.onFieldError}
                  onFieldErrorCleared={this.onFieldErrorCleared}
                  forceErrorCheck={this.state.forceErrChanges}
                  isRequired={true}
                />
              </div>
            </div>
            {/* <div className="row justify-content-center">
                        <div className="col-xs-12">
                        <FormFieldDropdown
                            symbol={"\u00A0"}
                            title="What are you looking to do?"
                            name="qa4"
                            options={['Purchasing first/next home','Refinancing your mortgage','Switching mortgages to CSCU','Other']}
                            value={this.useTempState() ? (this.state.localFormState.qa4 && (this.state.localFormState.qa4.A || "")) : (this.props.usrfields.qa4 && (this.props.usrfields.qa4.A || ""))}
                            onChange={(title,e)=>{let value = e.target ? e.target.value : e; this.onUsrFieldChange(title, {Q: "What are you looking to do?", A: value})}}
                            isRequired={true}
                            onFieldError={this.onFieldError}
                            onFieldErrorCleared={this.onFieldErrorCleared}
                        />
                    </div>
                    </div> */}
            {/* <div className="row">
              <div className="col-xs-12">
                <FormTextArea
                  title="Comment"
                  name="qa5"
                  value={
                    this.useTempState()
                      ? this.state.localFormState.qa5 &&
                        (this.state.localFormState.qa5.A || "")
                      : this.props.usrfields.qa5 &&
                        (this.props.usrfields.qa5.A || "")
                  }
                  onChange={(title, e) => {
                    let value = e.target ? e.target.value : e;
                    this.onUsrFieldChange(title, {
                      Q: "What is your message",
                      A: value,
                    });
                  }}
                  matchesRegex={
                    {
                      regex: "[a-zA-Z0-9]{1,}",
                      type: "warning",
                      message: "Your comment is blank",
                    }
                    //Comment not required as it could cause drop off
                  }
                  onFieldError={this.onFieldError}
                  onFieldErrorCleared={this.onFieldErrorCleared}
                  forceErrorCheck={this.state.forceErrChanges}
                  maxChars={1505}
                  rows={3}
                />
              </div>
            </div> */}
            <div className="row">
              <div className="col-xs-12">
                <FormCheckBox
                  // eslint-disable-next-line react/jsx-no-target-blank
                  text={
                    <p>
                      I agree to the{" "}
                      <a
                        href="https://www.comsavings.com/privacy"
                        target="_blank"
                      >
                        Privacy Policy
                      </a>{" "}
                      and give{" "}
                      <a
                        href="https://www.comsavings.com/legal/marketing-consent"
                        target="_blank"
                      >
                        Marketing Consent
                      </a>
                    </p>
                  }
                  name="terms"
                  forceErrorCheck={this.state.forceErrChanges}
                  onFieldError={this.onFieldError}
                  onFieldErrorCleared={this.onFieldErrorCleared}
                  onChange={this.onUsrFieldChange}
                  errMessage={
                    "You must agree to the terms and conditions before continuing."
                  }
                />
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row center-column-flow pt-20px">
              <div className="col-12">
                <FormBtn
                  text={
                    this.props.buttonText ? this.props.buttonText : "Submit"
                  }
                  className="primary"
                  disableText="Please wait..."
                  disabled={this.state.disableSubmit}
                />
              </div>
              <div className="col-12">
                {this.state.error.show ? (
                  <p className="text-align-center standAloneError">
                    <span className="icon"></span>
                    {this.state.error.errorMsg}
                  </p>
                ) : (
                  <p className="text-align-center">
                    {/*#1719 Removed calculator text*/}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="lead-input"></div>
      </form>
    );
  }
}

ContactForm.propTypes = {
  postSumbit: PropTypes.func,
  buttonText: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  return {
    updateusrfield: (title, value) => {
      dispatch(updateusrfield(value, title));
    },
    updateValidationStatus: (action, value) => {
      dispatch(updateValidationStatus(action, value));
    },
    setsubmitted: (value) => {
      dispatch(setsubmitted(value));
    },
  };
}

function mapStateToprops({ usrfields }, props) {
  return {
    usrfields: usrfields,
    props,
  };
}

export default connect(mapStateToprops, mapDispatchToProps)(ContactForm);
